import { apiPost, ApiError } from '.';

/**
 * Запрос серий продуктов
 */
const apiMapObjectSet = async (model) => apiPost('/map/object/set', model);
export default apiMapObjectSet;
